import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahDreamOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ----------------------------------------
  // LOAD ORDERS
  // ----------------------------------------
  const loadOrders = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_BASE}/api/VDreamOrders`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOrders(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load Dream orders.");
    }

    setLoading(false);
  };

  useEffect(() => {
    loadOrders();
  }, []);

  // ----------------------------------------
  // DELETE ORDER
  // ----------------------------------------
  const deleteOrder = async (id) => {
    if (!window.confirm("Delete this order?")) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(`${API_BASE}/api/VDreamOrders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOrders((prev) => prev.filter((o) => o.id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete order.");
    }
  };

  // ----------------------------------------
  // TABLE UI
  // ----------------------------------------
  if (loading) return <p style={{ padding: 40 }}>Loading Dream orders...</p>;
  if (error) return <p style={{ padding: 40, color: "red" }}>{error}</p>;

  return (
    <div style={{ padding: "40px" }}>
      <h1 style={{ marginBottom: "25px" }}>VOYAH DREAM — Orders</h1>

      {orders.length === 0 ? (
        <p>No orders yet.</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr style={{ background: "#f5f5f5" }}>
              <th style={th}>ID</th>
              <th style={th}>Customer</th>
              <th style={th}>Contact</th>
              <th style={th}>Address</th>
              <th style={th}>Offer</th>
              <th style={th}>Selections</th>
              <th style={th}>Price</th>
              <th style={th}>Date</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((o) => {
              let equipment = [];
              try {
                equipment = JSON.parse(o.selectedEquipmentJson);
              } catch {}

              return (
                <tr key={o.id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={td}>{o.id}</td>

                  {/* Customer */}
                  <td style={td}>
                    <div>{o.firstName} {o.surname}</div>
                    <small>{o.email}</small>
                  </td>

                  {/* Contact */}
                  <td style={td}>{o.phone}</td>

                  {/* Address */}
                  <td style={td}>
                    {o.address}, {o.city}
                  </td>

                  {/* Offer Type */}
                  <td style={td}>
                    {o.offerType === "buy" ? "Buy" : "Lease"}
                  </td>

                  {/* Vehicle Selections */}
                  <td style={td}>
                    <div>Exterior: {o.selectedExterior}</div>
                    <div>Interior: {o.selectedInterior}</div>
                    <div>
                      Equipment:{" "}
                      {equipment.length === 0
                        ? "None"
                        : equipment.join(", ")}
                    </div>
                  </td>

                  {/* Price */}
                  <td style={td}>
                    {o.currency?.toUpperCase()}{" "}
                    {o.finalPrice?.toLocaleString("en-US")}
                  </td>

                  {/* Date */}
                  <td style={td}>
                    {new Date(o.createdAt).toLocaleString()}
                  </td>

                  {/* DELETE */}
                  <td style={td}>
                    <button
                      onClick={() => deleteOrder(o.id)}
                      style={{
                        padding: "6px 10px",
                        background: "#c62828",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

// ----------------------------------------
// TABLE CELL STYLES
// ----------------------------------------
const th = {
  padding: "10px",
  borderBottom: "2px solid #ccc",
  textAlign: "left",
};

const td = {
  padding: "10px 8px",
  verticalAlign: "top",
};

export default VoyahDreamOrders;
